import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/tokenService";

const PfEsicDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const token = await getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/user/profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserData(response.data);
      } catch (err) {
        setError("Failed to load PF/ESIC details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading PF/ESIC details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  const hasPfEsicData =
    Boolean(userData?.uan_esic_added) ||
    Boolean(userData?.uan_number) ||
    Boolean(userData?.esic_number);

  return (
    <div className="container py-4">
      <div className="card shadow-sm">
        <div className="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center">
          <h3 className="mb-0">My PF/ESIC Details</h3>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => navigate("/user_dashboard/add_uan_esic")}
          >
            {hasPfEsicData ? "Edit" : "Add"} PF/ESIC
          </button>
        </div>
        <div className="card-body">
          {!hasPfEsicData ? (
            <div className="text-center py-4">
              <p className="text-muted mb-3">No PF/ESIC details submitted yet.</p>
              <button
                className="btn btn-outline-primary"
                onClick={() => navigate("/user_dashboard/add_uan_esic")}
              >
                Submit PF/ESIC Form
              </button>
            </div>
          ) : (
            <div className="row g-3">
              <div className="col-md-6">
                <div className="border rounded p-3 h-100">
                  <div className="text-muted mb-1">UAN Number</div>
                  <div className="fw-semibold">{userData?.uan_number || "N/A"}</div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="border rounded p-3 h-100">
                  <div className="text-muted mb-1">ESIC Number</div>
                  <div className="fw-semibold">{userData?.esic_number || "N/A"}</div>
                </div>
              </div>
              <div className="col-12">
                <div className="border rounded p-3">
                  <div className="text-muted mb-1">Submission Status</div>
                  <span
                    className={`badge ${
                      userData?.uan_esic_added ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {userData?.uan_esic_added ? "Submitted" : "Pending"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PfEsicDetails;
